/** Inventory daily-task types that navigate away from the daily-tasks list. */
export const INVENTORY_TASK_TYPE = {
  ADD_VENDORS: 'Add Vendors',
  CREATE_INVENTORY: 'Create Inventory'
};

/** Management priority: review completed inventory setup for a project. */
export const INVENTORY_SETUP_REVIEW_TYPE = 'Inventory Setup Review';

export function isCreateInventoryTaskType(type) {
  return type === INVENTORY_TASK_TYPE.CREATE_INVENTORY;
}

export function isAddVendorsTaskType(type) {
  return (
    type === INVENTORY_TASK_TYPE.ADD_VENDORS || type?.toLowerCase() === 'add vendors'
  );
}

/**
 * Navigate for known inventory task types. Returns true if navigation occurred.
 */
export function navigateForInventoryTaskType(navigate, type, { projectId, replace = false } = {}) {
  if (isAddVendorsTaskType(type)) {
    navigate('/builder/inventory/vendors', replace ? { replace: true } : undefined);
    return true;
  }

  if (isCreateInventoryTaskType(type)) {
    const options = {};
    if (replace) options.replace = true;
    if (projectId != null && projectId !== '') {
      options.state = { projectID: Number(projectId) };
    }
    navigate('/builder/inventory/stock', options);
    return true;
  }

  return false;
}

export function isInventorySetupReviewType(type) {
  return type === INVENTORY_SETUP_REVIEW_TYPE;
}

/** Open stock page for management inventory setup review. */
export function navigateInventorySetupReview(
  navigate,
  projectId,
  { priorityId, inventorySetupReviewCompleted } = {}
) {
  if (projectId == null || projectId === '') return false;
  const state = { projectID: Number(projectId) };
  if (priorityId != null) state.priorityId = Number(priorityId);
  if (inventorySetupReviewCompleted) state.inventorySetupReviewCompleted = true;
  navigate('/builder/inventory/stock', { state });
  return true;
}
